import React, { ReactNode } from "react";
import {
    RiCommandFill,
    RiQuestionLine,
} from "react-icons/ri";
import { useHelpContext } from "../../contexts/HelpContext";
import { useKeyboardState } from "../../contexts/KeyboardShortcutContext";
import Feedback from "../feedback/Feedback";
import Help from "../help/Help";
import Button from "../theme/button/Button";
import Styles from "./TopPanel.module.scss";

interface TopPanelProps {
    prefixButton?: ReactNode
    title: ReactNode;
    buttons?: ReactNode;
    children?: ReactNode;
}

const TopPanel = React.forwardRef((
    {
        title, prefixButton, buttons, children,
    }: TopPanelProps,
    ref: React.ForwardedRef<HTMLDivElement>,
): ReactNode => {
    const helpContext = useHelpContext();
    const keyboard = useKeyboardState();

    const helpId = helpContext.getArticleId();
    return (
        <div className={Styles.panel} ref={ref}>
            {prefixButton}
            <div className={Styles["panel-title"]}>
                <h3>{title}</h3>
            </div>

            {children && <div className={Styles["panel-content"]}>{children}</div>}

            <div className="d-flex gap3-05" data-tour-panel="search-create">
                {keyboard.hasCustomCommands("default") && (
                    <Button
                        size="small"
                        variant="ghost-gray"
                        prefixIcon={<RiCommandFill />}
                        onClick={() => keyboard.toggleShortcutsMenu()}
                    />
                )}
                {buttons}

                {helpId && (
                    <Help
                        articleId={helpId}
                        buttonClassName="btn btn-ghost-gray btn-small btn-icon-only"
                        button={(
                            <div className="btn-icon">
                                <RiQuestionLine />
                            </div>
                        )}
                    />
                )}

                <Feedback />
            </div>
        </div>
    );
});

TopPanel.defaultProps = {
    prefixButton: undefined,
    buttons: undefined,
    children: undefined,
};

export default TopPanel;
